/* eslint-disable no-console */

import "whatwg-fetch";
import Vue from "vue";
import App from "./App.vue";
import { sync } from "vuex-router-sync";
import { createRouter } from "./router";
import { createStore } from "./store";
import { createI18n } from "./i18n";
import { createProvider } from "./apollo";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import VueMeta from "vue-meta";
import VeeValidate from "vee-validate";
import packageJson from "../package.json";
import Configuration from "./config/config";

/* get application environment */
const packageVersion = packageJson.name + "@" + packageJson.version;
const sentryLogger = Configuration.value("VUE_APP_SENTRY_LOGGER");
const sentryEnabled = Configuration.value("VUE_APP_SENTRY_ENABLED") === "true";
let environment = process.env.NODE_ENV;

if (sentryEnabled) {
    if (/review-rc-.*/.test(location.hostname)) {
        environment = "release";
    } else if (/review-.*/.test(location.hostname)) {
        environment = "review";
    }

    Sentry.init({
        release: packageVersion,
        dsn: sentryLogger,
        environment: environment,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
    });
}


Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(VeeValidate);

/**
 * @param {*=} context
 * @returns {{app: (Vue | CombinedVueInstance<Vue, object, object, object, Record<never, any>>)}}
 */
export function createApp(context?: any) {
    const router = createRouter();
    const store = createStore();
    const i18n = createI18n();
    const apollo = createProvider(context, {
        errorLogger: sentryEnabled ? Sentry : null
    });

    sync(store, router);

    const app = new Vue({
        router,
        store,
        i18n,
        apolloProvider: apollo,
        render: h => h(App)
    }).$mount("#app");

    return {app, router, store, i18n, apollo};
}

createApp();
